import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const SearchCompany = "/api/business/listCompany";
const FeeTyoe = "/api/business/feeType";
const AllCompany = "/api/business/companyList";
const companyType = "/api/business/companyType";
const exportExcell = "/api/business/listCompany/export-excel?page=0&size=10000";
const ContacPerson = "/api/business/contactPerson";

const networkType = "/api/business/cert/network-type";
const LicNumber = "/api/business/cert/lic-numbers";
// const getAllotments = '/api/business/receipts/{receipt_id}/allotments'
// thong tin chung
const companyDetail = "/api/business/CompanyDetail";
const updateCpn = "api/business/CompanyUpdate";
const getfinanPeriod = "/api/business/finanPeriod";
const generalHistory = "/api/business/company-detail-history";
// thông tin liên hệ
const updateContact = "/api/business/company-contact-update";
const ContactHistory = "/api/business/contact-authorization-history";
//lịch sử cấp phép
// const SearchLicHis = '/api/business/company-licCpnInfor?id=26&page=0&size=3000'
const LicNumberCCDV = "/api/business/company-lic-number";
//Lịch sử đôn đốc
const callforcompany = "/api/business/add-call-for-company";
const apiUserCall = "/api/business/find-user-role?name=Lịch sử đôn đốc";
export default class CompanyService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public SearchCompany(querySearch: any, page: any, cancelToken): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(SearchCompany + `?` + this.convertObjectParamToStrings.convertObjectParamToStrings(page), querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllCompany(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(AllCompany, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getCompanyType(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(companyType)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public AllFeetype(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(FeeTyoe, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public ExportExcel(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(exportExcell, querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getContacPerson(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(ContacPerson)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public genetalHistory(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(generalHistory + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(querySearch))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // thông tin chung
  public getfinanPeriod(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(getfinanPeriod)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getDetail(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(companyDetail + `?id=` + querySearch.id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public UpdateCpn(id?: number, querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(updateCpn + `?id=${id}`, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //thông tin liên hệ
  public UpdateContact(id?: number, querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(updateContact + `?id=${id}`, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public ContactHistory(params?: any, querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(ContactHistory + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(params), querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // lịch sủ cấp phép
  public getLicNumber(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/lic-number")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getNetwork(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/network-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public dowloadExcelCP(id: number, querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/company/excel-licInfor?id=${id}`, querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public searchLicHis(param?: any, querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/company-licCpnInfor?id=${param.id}&page=${param.page}&size=${param.size}`, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //Lịch sử BCDT
  public searchHisBCDT(id?: number, querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/company-revenueInfor?id=${id}`, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public NetworkType(id?: number, querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(networkType)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public LicnumbeCCDV(params?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(LicNumberCCDV + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(params))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public dowloadExcelBCDT(id: number, querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/company/excel-RevenueInfor?id=${id}`, querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //Lịch sử đôn đốc
  public callforcompany(query?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(callforcompany, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getUserCall(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(apiUserCall)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
